import _ from 'underscore'
elm = require('../../../../elm/elm.js')

getBoundingClient = (node) ->
  client = node.getBoundingClientRect();
  {
    top: Math.round(client.top),
    bottom: Math.round(client.bottom),
    left: Math.round(client.left),
    right: Math.round(client.right),
    height: Math.round(client.height),
    width: Math.round(client.width),
  }

updateBoundingCient = (builder, columnBuilder, app) ->
  builderClient = getBoundingClient(builder)
  columnBuilderClient = getBoundingClient(columnBuilder)
  app.ports.setBoundingClient.send(builderClient)
  app.ports.setColumnBuilderClient.send(columnBuilderClient)

updateColumnBuilderScroll = (columnBuilder, app) ->
  scrollLeft = Math.round(columnBuilder.scrollLeft)
  app.ports.setCurrentBuilderScroll.send(scrollLeft)


normalizeFlags = (flags) ->
  flags.filters.forEach (flag) ->
    if flag.filter_select
      flag.filter_select.options = flag.filter_select.options.map((opt) -> [opt.id, opt.name])

  return flags


handleRedirect = () ->
  window.location = '/manage/reports'

handleShowMultiSelect = ([fieldName, title, options, selected]) ->
  app = this

  select = """
    <select multiple id='report-builder-multi-select'></select>
  """

  footer = """
    <button type="button" data-dismiss="modal" class="btn btn-primary close-report-builder-select">Save</button>
  """

  modal = m = window.get_modal_markup()
  content = window.get_modal_content(title, select, footer)

  modal.html(content)


  $('#report-builder-multi-select').select2({
    theme: "bootstrap",
    placeholder: '+ Add',
    data: options.map (option) ->
        { id: option[0], text: option[1], selected: selected.indexOf(option[0]) >= 0 }
  })

  $('#report-builder-multi-select').on('change', (args) ->
    val = $(this).val() || []
    app.ports.updateMultiSelect.send([fieldName, val])
  )

  m.modal();

$ ->
  if $('#report-builder-container').length > 0
    node = $('#report-builder-container').get(0)
    flags = normalizeFlags($('#report-builder-container').data('flags'))

    flags.boundingClient = getBoundingClient(node)
    flags.todaysDate = Date.now()

    app = elm.ReportBuilder.embed(node, flags)
    app.ports.redirectToManage.subscribe handleRedirect
    app.ports.showMultiSelectModal.subscribe handleShowMultiSelect.bind(app)

    # We need the boundingClientRect for the columnBuilder to do some calculations,
    # this is not in the DOM on the initial render, it happens in the elm.embed,
    # which is asynchrnous, though, doens't expose a callback / promise,
    # so we're using setTimout to put it in the event loop after the elm.embed call
    setTimeout(() ->
      columnBuilder = $('.report-info-fields-container').get(0)
      builderBody = $('.report-builder-body').get(0)

      # An additional buffer to ensuer columnBuilder is defined in the DOM
      while !columnBuilder
        columnBuilder = $('.report-info-fields-container').get(0)

      while !builderBody
        builderBody = $('.report-builder-body').get(0)

      updateBoundingCient(builderBody, columnBuilder, app)
      window.onresize = _.debounce(updateBoundingCient.bind(null, builderBody, columnBuilder, app), 250)
      columnBuilder.onscroll = updateColumnBuilderScroll.bind(null, columnBuilder, app)
    , 0)
